/* =======================================
 * Email address (de)obfuscation
 * ======================================= */ // @decalin
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== "undefined";
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $238ac70369f38756$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== "body" || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === "rtl") x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $238ac70369f38756$export$89e651af02346cd4)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== "body" || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "static";
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $238ac70369f38756$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ((0, $238ac70369f38756$export$89e651af02346cd4)(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $238ac70369f38756$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};


const $54b47fc030b7b21e$var$address = ">2CE:;?o5642=:?]36";
function $54b47fc030b7b21e$var$rot47(x) {
    let s = [];
    for(let i = 0; i < x.length; i++){
        var j = x.charCodeAt(i);
        if (j >= 33 && j <= 126) s[i] = String.fromCharCode(33 + (j + 14) % 94);
        else s[i] = String.fromCharCode(j);
    }
    return s.join("");
}
document.querySelectorAll("[data-mailto]").forEach(function(el) {
    el.href = "mailto:" + $54b47fc030b7b21e$var$rot47($54b47fc030b7b21e$var$address);
});
document.querySelectorAll("[data-text]").forEach(function(el) {
    el.innerText = $54b47fc030b7b21e$var$rot47($54b47fc030b7b21e$var$address);
});
document.querySelectorAll("abbr[aria-label]").forEach((element)=>{
    const tooltip = document.createElement("span");
    tooltip.classList.add("tooltip");
    tooltip.innerHTML = element.getAttribute("aria-label");
    element.parentNode.insertBefore(tooltip, element);
    const show = ()=>{
        tooltip.style.display = "inline-block";
        (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(element, tooltip, {
            placement: "bottom-start",
            middleware: [
                (0, $461947879dcdbcd4$export$cc800923e997bb8)(6),
                (0, $461947879dcdbcd4$export$8a83211c878a3f1f)(),
                (0, $461947879dcdbcd4$export$fba63a578e423eb)({
                    padding: 5
                })
            ]
        }).then(({ x: x, y: y, placement: placement, middlewareData: middlewareData })=>{
            Object.assign(tooltip.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
        document.addEventListener("touchstart", ()=>element.blur(), {
            once: true
        });
    };
    const hide = ()=>{
        tooltip.style.display = "";
    };
    [
        [
            "mouseenter",
            show
        ],
        [
            "mouseleave",
            hide
        ],
        [
            "focus",
            show
        ],
        [
            "blur",
            hide
        ]
    ].forEach(([event, listener])=>{
        element.addEventListener(event, listener);
    });
});


//# sourceMappingURL=index.bcb39b62.js.map
